// Display copy of apps/functions/src/journey.ts (keep the two in sync). The server copy decides
// whether a certificate is issued; this one only draws the map.
export const FINISH_RATIO = 0.8;
export const AMF_MODULE_COURSE: Record<number, string> = {
  1: "ai-sales-system", 2: "ai-sales-system",
  3: "ai-money-factory-2", 4: "ai-money-factory-2",
  5: "ai-sales-system-pro", 6: "ai-sales-system-pro", 7: "ai-sales-system-pro",
};

export type LessonLite = { id: string; sectionTitle?: string; published?: boolean };
export type ModuleStatus = { n: number; lessonsDone: number; lessonsTotal: number; quiz: boolean; homework: boolean; done: boolean };

/** Module number from a section title like "Module 3 | ..." (0 = not a module, e.g. Intro). */
export function moduleOf(sectionTitle?: string): number {
  const m = /^\s*Module\s+(\d+)\b/i.exec(sectionTitle ?? "");
  return m ? Number(m[1]) : 0;
}

/** Modules that hand in homework only, no quiz (Module 4 = the finished website link, Dew 2026-10-27). */
export const NO_QUIZ_MODULES = new Set([4]);

export function amfStatus(
  lessons: LessonLite[],
  doneLessonIds: Set<string>,
  quizModules: Set<number>,
  homeworkModules: Set<number>
): ModuleStatus[] {
  return Object.keys(AMF_MODULE_COURSE).map(Number).map((n) => {
    // Quiz lessons count through the quiz itself, not as a lesson to finish.
    const mine = lessons.filter((l) => l.published && moduleOf(l.sectionTitle) === n && !l.id.startsWith("quiz-"));
    const lessonsDone = mine.filter((l) => doneLessonIds.has(l.id)).length;
    const quiz = NO_QUIZ_MODULES.has(n) || quizModules.has(n);
    const homework = homeworkModules.has(n);
    const lessonsOk = mine.length === 0 || lessonsDone >= Math.ceil(mine.length * FINISH_RATIO);
    return { n, lessonsDone, lessonsTotal: mine.length, quiz, homework, done: lessonsOk && quiz && homework };
  });
}

/** Certificate name: what the student typed, trimmed and capped; "" if unusable. */
